import { withInstall } from '@vuemap/vue-amap-util'
import DistrictCluster from './DistrictCluster.vue'

export const ElAmapLayerDistrictCluster = withInstall(DistrictCluster)
export default ElAmapLayerDistrictCluster
